import React, { useState, useEffect, useRef } from 'react';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Aside from './Aside';
import axios from 'axios';
import delat from '../assets/images/dummy-user.jpg';
import Swal from 'sweetalert2';
import { useProfileImage } from './useProfileImage';
import CryptoJS from 'crypto-js';

const encryptId = (id) => {
    const secretKey = '12345';
    const encrypted = CryptoJS.AES.encrypt(id.toString(), secretKey).toString();
    const sanitizedEncrypted = encrypted.replace(/\//g, '');
    return sanitizedEncrypted;
};


const Settings = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [instagram_id, setInstagramId] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [current, setCurrent] = useState('');
    const [password, setPassword] = useState('');
    const [passre, setPassre] = useState('');
    const [country, setCountry] = useState('');
    const [timezone, setTimezone] = useState('');
    const [countries, setCountries] = useState([]);
    const [timezones, setTimezones] = useState([]);
    const { profileImage, setProfileImage } = useProfileImage();
    const [tempImage, setTempImage] = useState(profileImage);
    const [isDeleted, setIsDeleted] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const authNData = localStorage.getItem('auth');
    const userAid = authNData ? JSON.parse(authNData).id : null;

    useEffect(() => {
        try {
            const authData = localStorage.getItem('auth');
            if (authData) {
                const parsedData = JSON.parse(authData);
                setName(parsedData.name || '');
                setEmail(parsedData.email || '');
                setInstagramId(parsedData.instagram_id || '');
                setCountry(parsedData.country?.code || '');
                setTimezone(parsedData.timezone || '');
                setPhoneNumber(parsedData.phone_number || '');
                setBusinessName(parsedData.business_name || '');
            }
        } catch (error) {
            console.error('Error retrieving data from localStorage:', error);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const newErrors = {};
        if (!country) newErrors.country = 'Country is required.';
        if (!timezone) newErrors.timezone = 'Timezone is required.';
        if (!name) newErrors.name = 'Name is required.';
        if (!instagram_id) newErrors.instagram_id = 'Instagram Id is required.';
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setLoading(false);
            return;
        }

        try {
            const authData = localStorage.getItem('auth');
            const token = authData ? JSON.parse(authData).token : null;
            const user_id = authData ? JSON.parse(authData).id : null;
            const formData = new FormData();
            if (tempImage) {
                formData.append('image', tempImage);
            }
            const encryptedId = encryptId(user_id);
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/api/users/${encryptedId}`,
                {
                    'name': name,
                    'user_id': user_id,
                    'email': email,
                    'instagram_id': instagram_id,
                    'phone_number': phoneNumber,
                    'country': country,
                    'timezone': timezone,
                    'business_name': businessName,
                    'image': tempImage,
                    'imageDeleted': isDeleted,
                },
                {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Authorization': 'Bearer ' + token,
                    },
                }
            );

            if (response.data.status === 200) {
                Swal.fire({
                    text: response.data.message,
                    icon: 'success',
                    title: 'Success!',
                    confirmButtonText: 'Ok'
                });
                setLoading(false);
                handleSaveChanges();
                const authData = localStorage.getItem('auth');
                const isAuthenticated = authData ? JSON.parse(authData).token : null;
                response.data.user.token = isAuthenticated
                localStorage.setItem('auth', JSON.stringify(response.data.user));
            } else if (response.data.status === 422) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    phone_number: response.data.message?.phone_number?.[0] || '',
                }));
                setLoading(false);
            } else if (response.data.status === 401) {
                navigate('/login');
                localStorage.removeItem('auth')
            } else {
                alert('Failed to update profile.');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const savedImage = localStorage.getItem('profileImage' + userAid);
        if (savedImage) {
            setTempImage(savedImage);
        }
    }, []);

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {

            const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "image/webp", "image/svg+xml"];

            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    text: 'Invalid file type! Please upload a .png, .jpg, .jpeg, .webp, or .svg file.',
                    icon: 'error',
                    title: 'Error!',
                    confirmButtonText: 'Ok'
                });
                event.target.value = "";
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                const imageUrl = reader.result;
                setTempImage(imageUrl);
                setIsDeleted(0);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSaveChanges = () => {
        if (isDeleted) {
            setProfileImage(null);
            localStorage.removeItem('profileImage' + userAid);
        } else {

            setProfileImage(tempImage);
            localStorage.setItem('profileImage' + userAid, tempImage);
        }
        setIsDeleted(0);
        setLoading(false);
    };

    const deleteimage = () => {
        setTempImage(null);
        setIsDeleted(1);
    };

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        setLoading2(true);
        const newErrors = {};
        if (!current) newErrors.current = 'Current Password is required.';
        if (!password) newErrors.password = 'New Password is required.';
        if (!passre) newErrors.passre = 'New Password is required.';
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setLoading2(false);
            return;
        }

        try {
            setLoading2(true);
            const authData = localStorage.getItem('auth');
            const token = authData ? JSON.parse(authData).token : null;
            const user_id = authData ? JSON.parse(authData).id : null;
            if (!token) {
                alert('You must be logged in to update your profile.');
                setLoading2(false);
                return;
            }
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/change-password/`,
                {
                    user_id,
                    old_password: current,
                    new_password: password,
                    confirm_password: passre,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status === 200) {
                Swal.fire({
                    text: response.data.message,
                    icon: 'success',
                    title: 'Success!',
                    confirmButtonText: 'Ok'
                });
                setPassre('');
                setPassword('');
                setCurrent('');
                setLoading2(false);
            } else if (response.data.status === 422) {
                const responseErrors = response.data.message || {};
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    passre: responseErrors.confirm_password ? responseErrors.confirm_password[0] : '',
                    password: responseErrors.new_password ? responseErrors.new_password[0] : '',
                    current: responseErrors.old_password ? responseErrors.old_password[0] : '',
                    current: responseErrors.old_password ? responseErrors.old_password : '',
                }));
                setLoading2(false);
            } else if (response.data.status === 401) {
                navigate('/login');
                localStorage.removeItem('auth')
            } else {
                alert('Failed to update Password.');
            }
        } catch (error) {
            console.error('Error updating Password:', error);
        } finally {
            setLoading2(false);
        }
    };

    const storedAuthData = localStorage.getItem('auth');
    const authData = storedAuthData ? JSON.parse(storedAuthData) : null;
    const [isFormVisible2, setIsFormVisible2] = useState(authData?.has_password ? true : false);
    const [isFormVisible, setIsFormVisible] = useState(authData?.has_password ? false : true);
    const [newPassowrd, setNewPassowrd] = useState();
    const [confirmnewPassword, setConfirmnewPassword] = useState();

    const handleFormEmailSubmit = async (event) => {
        event.preventDefault();
        setLoading3(true);
        const newErrors = {};
        if (!newPassowrd) newErrors.newPassowrd = 'New Password is required.';
        if (!confirmnewPassword) newErrors.confirmnewPassword = 'Confirm password is required.';
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setLoading3(false);
            return;
        }

        try {
            const inpData = {
                'new_password': newPassowrd,
                'confirm_password': confirmnewPassword,
            };

            const token = authData ? authData.token : null;
            const user_id = authData ? authData.id : null;
            const userData = {
                user_id,
                inpData
            };
            if (!token) {
                alert('You must be logged in to update your profile.');
                setLoading3(false);
                return;
            };
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/set-password/${token}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ` + token,
                    },
                    body: JSON.stringify(userData),
                });
            const responseData = await response.json();

            if (responseData.status === 200) {
                Swal.fire({
                    text: responseData.message,
                    icon: 'success',
                    title: 'Success!',
                    confirmButtonText: 'Ok'
                });
                setLoading3(false);
                const authData = localStorage.getItem('auth');
                const aData = JSON.parse(authData);
                aData.has_password = true;
                localStorage.setItem('auth', JSON.stringify(aData));
                setIsFormVisible(false);
            } else if (responseData.status === 422) {
                const responseErrors = responseData.message || {};
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    newPassowrd: responseErrors.new_password ? responseErrors.new_password[0] : '',
                    confirmnewPassword: responseErrors.confirm_password ? responseErrors.confirm_password[0] : '',
                }));
                setLoading3(false);
            } else if (responseData.status === 401) {
                navigate('/login');
                localStorage.removeItem('auth')
            } else {
                alert('Failed to update Password.');
            };
        } catch (error) {
            console.error('Error updating Password:', error);
        } finally {
            setLoading3(false);
        };
    };

    useEffect(() => {
        const fetchCountriesAndTimezones = async () => {
            try {
                const authData = localStorage.getItem('auth');
                const token = authData ? JSON.parse(authData).token : null;
                const countryResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/countries`, {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                    },
                });
                setCountries(countryResponse.data.countries);
                const timezoneResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/timezones`, {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                    },
                });

                setTimezones(timezoneResponse.data.timezones);
            } catch (error) {
                console.error('Error fetching data:', error.response || error.message);
                if (error.response?.status === 401) {
                    alert('Unauthorized access. Please log in again.');
                };
            };
        };

        fetchCountriesAndTimezones();
    }, []);

    const [countryFilter, setCountryFilter] = useState("");
    const [timezoneFilter, setTimezoneFilter] = useState("");

    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [showTimezoneDropdown, setShowTimezoneDropdown] = useState(false);

    const countryDropdownRef = useRef(null);
    const timezoneDropdownRef = useRef(null);

    const handleCountrySelect = (code) => {
        setCountry(code);
        setShowCountryDropdown(false);
        setTimezone('');
    };

    const handleTimezoneSelect = (value) => {
        setTimezone(value);
        setShowTimezoneDropdown(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                countryDropdownRef.current &&
                !countryDropdownRef.current.contains(event.target)
            ) {
                setShowCountryDropdown(false);
            };

            if (
                timezoneDropdownRef.current &&
                !timezoneDropdownRef.current.contains(event.target)
            ) {
                setShowTimezoneDropdown(false);
            };
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordRe, setShowPasswordRe] = useState(false);
    const [showPasswordRec, setShowPasswordRec] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const togglePasswordVisibilityRe = () => {
        setShowPasswordRe(!showPasswordRe);
    };
    const togglePasswordVisibilityRec = () => {
        setShowPasswordRec(!showPasswordRec);
    };
    const handleInputChangephone = (e) => {
        const input = e.target.value.replace(/\D/g, "");
        let formattedInput = "";
        if (input.length > 0) formattedInput = `(${input.slice(0, 3)}`;
        if (input.length > 3) formattedInput += `) ${input.slice(3, 6)}`;
        if (input.length > 6) formattedInput += `-${input.slice(6, 10)}`;
        setPhoneNumber(formattedInput);
    };
    const inputRef = useRef(null);
    const inputRef2 = useRef(null);
    useEffect(() => {
        if (showCountryDropdown && inputRef.current) {
            inputRef.current.focus();
        };
        if (showTimezoneDropdown && inputRef2.current) {
            inputRef2.current.focus();
        };
    }, [showCountryDropdown, showTimezoneDropdown])

    return (
        <div>
            <Header />
            <div style={{ display: 'flex' }}>
                <div style={{ zIndex: '101', background: 'white', boxShadow: '0 .8rem 1rem rgba(0, 0, 0, .15)', position: 'fixed', height: '100vh', }}>
                    <Aside />
                </div>
                <div className='mainstylle paddtop'>
                    <div className="container py-4 px-2 ">
                        <div className="row setting">
                            <div className="col-md-12">
                                {/* Profile Settings Card */}
                                <div className="card rounded-4 mb-5 mb-xl-10" style={{ background: 'white', marginTop: '60px' }}>
                                    {/* Card Header */}
                                    <div className="card-header  rounded-4  border-0 cursor-pointer" role="button" style={{ background: 'white' }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0 p-info-header make_blur">Profile Details</h3>
                                        </div>
                                    </div>

                                    {/* Profile Details Section */}
                                    <div id="kt_account_settings_profile_details" className="collapse show">
                                        <form onSubmit={handleSubmit} encType='multipart/form-data' className="form fv-plugins-bootstrap5 fv-plugins-framework">
                                            <div className="card-body border-top p-9">
                                                <div className="row">
                                                    {/* Avatar Upload */}
                                                    <div className="form-group col-md-12 mt-2 mb-2">
                                                        <div className="u-avatar-upload">
                                                            <div className="u-avatar-edit">
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    id="imageUpload"
                                                                    name="image"
                                                                    className="imageUpload"
                                                                    // accept=".png, .jpg, .jpeg, .webp, .svg"
                                                                    onChange={handleImageUpload}
                                                                />
                                                                <label htmlFor="imageUpload"></label>
                                                            </div>
                                                            <div className="u-avatar-preview">
                                                                {tempImage ? (
                                                                    <div className="imagePreview" style={{ backgroundImage: `url(${tempImage})` }}></div>
                                                                ) : (
                                                                    <div className="imagePreview" style={{ backgroundImage: `url(${delat})` }}></div>
                                                                )}
                                                                <a style={{ display: tempImage ? 'block' : 'none', }} className="deleteImage shadow-sm bg-body" onClick={deleteimage}>
                                                                    <i className="fa fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Name Input */}
                                                    <div className="form-group col-md-6 mt-2 mb-2">
                                                        <label htmlFor="name" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Name <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <input type="text"
                                                            className={`form-control uprofile update-profile-name-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0 ${errors.name ? "is-invalid" : ""}`}
                                                            name="name" value={name}
                                                            onChange={(e) => setName(e.target.value)} placeholder="Enter Name" />
                                                        {errors.name && <span className="error-msgs text-danger">{errors.name}</span>}
                                                    </div>

                                                    {/* Email Input */}
                                                    <div className="form-group col-md-6 mt-2 mb-2">
                                                        <label htmlFor="email" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Email Address <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control text-muted uprofile update-profile-email-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0"
                                                            name="email"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            placeholder="Enter Email Address"
                                                            disabled readOnly
                                                        />
                                                    </div>

                                                    {/* Instagram ID Input */}
                                                    <div className=" form-group col-md-6 mt-2 mb-2 ">
                                                        <label htmlFor="instagramId" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Instagram ID <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control uprofile update-profile-instagram_id-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0 ${errors.instagram_id ? "is-invalid" : ""}`}
                                                            name="instagramId"
                                                            value={instagram_id}
                                                            onChange={(e) => setInstagramId(e.target.value)}
                                                            placeholder="Enter Instagram ID"

                                                        />
                                                        {errors.instagram_id && <span className="error-msgs text-danger">{errors.instagram_id}</span>}
                                                    </div>

                                                    {/* Phone Number Input */}
                                                    <div className="form-group col-md-6 mt-2 mb-2">
                                                        <label htmlFor="phoneNumber" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Phone Number</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control uprofile update-profile-phone_number-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0 ${errors.phone_number ? "is-invalid" : ""}`}
                                                            name="phone_number"
                                                            value={phoneNumber}
                                                            onChange={handleInputChangephone}
                                                            placeholder="Enter Phone Number"
                                                            data-mask="(999) 999-9999"
                                                        />
                                                        <em className="form-text">eg:- (xxx) xxx-xxxx</em> <br />
                                                        {errors.phone_number && <span className="error-msgs text-danger">{errors.phone_number}</span>}
                                                    </div>

                                                    {/* Country Dropdown */}
                                                    <div className="form-group col-md-6 mt-2 mb-2" ref={countryDropdownRef}>
                                                        <label htmlFor="country" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Country <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <div className="dropdown-container ">
                                                            <div
                                                                className={`dropdown-input form-control text-muted  form-control-lg form-control-solid ${errors.country ? "is-invalid" : ""}`}
                                                                onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                                                            >
                                                                {country ? countries.find((c) => c.code === country)?.name : "Choose Country"}
                                                            </div>
                                                            {showCountryDropdown && (
                                                                <div className="dropdown-list">
                                                                    <input
                                                                        type="text" ref={inputRef}
                                                                        className="dropdown-search"
                                                                        placeholder="Search Country"
                                                                        onChange={(e) => setCountryFilter(e.target.value.toLowerCase())}
                                                                    />
                                                                    {countries.length > 0 ? (
                                                                        countries
                                                                            .filter((c) => c.name.toLowerCase().includes(countryFilter))
                                                                            .map((c) => (
                                                                                <div
                                                                                    key={c.code}
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleCountrySelect(c.code)}
                                                                                >
                                                                                    {c.name}
                                                                                </div>
                                                                            ))
                                                                    ) : (
                                                                        <div className="dropdown-item">Loading...</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {errors.country && <span className="error-msgs text-danger">{errors.country}</span>}
                                                    </div>

                                                    {/* Timezone Dropdown */}
                                                    <div className="form-group col-md-6 mt-2 mb-2" ref={timezoneDropdownRef}>
                                                        <label htmlFor="timezone" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Timezone <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <div className="dropdown-container">
                                                            <div
                                                                className={`dropdown-input  form-control text-muted  form-control-lg form-control-solid ${errors.timezone ? "is-invalid" : ""}`}
                                                                onClick={() => setShowTimezoneDropdown(!showTimezoneDropdown)}
                                                            >
                                                                {timezone || "Choose Timezone"}
                                                            </div>
                                                            {showTimezoneDropdown && (
                                                                <div className="dropdown-list">
                                                                    <input
                                                                        type="text" ref={inputRef2}
                                                                        className="dropdown-search"
                                                                        placeholder="Search Timezone"
                                                                        onChange={(e) => setTimezoneFilter(e.target.value.toLowerCase())}
                                                                    />
                                                                    {Object.keys(timezones).length > 0 ? (
                                                                        Object.keys(timezones)
                                                                            .filter(
                                                                                (region) =>
                                                                                    region.toLowerCase().includes(timezoneFilter) ||
                                                                                    Object.values(timezones[region]).some((tz) =>
                                                                                        tz.toLowerCase().includes(timezoneFilter)
                                                                                    )
                                                                            )
                                                                            .map((region) => (
                                                                                <div key={region} className="dropdown-group">
                                                                                    <div className="dropdown-group-label ">{region}</div>
                                                                                    {Object.entries(timezones[region])
                                                                                        .filter(([key, value]) =>
                                                                                            value.toLowerCase().includes(timezoneFilter)
                                                                                        )
                                                                                        .map(([key, value]) => (
                                                                                            <div
                                                                                                key={key}
                                                                                                className="dropdown-item "
                                                                                                onClick={() => handleTimezoneSelect(value)}
                                                                                            >
                                                                                                {value}
                                                                                            </div>
                                                                                        ))}
                                                                                </div>
                                                                            ))
                                                                    ) : (
                                                                        <div className="dropdown-item">Loading...</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {errors.timezone && <span className="error-msgs text-danger">{errors.timezone}</span>}
                                                    </div>

                                                    {/* Business Name Input */}
                                                    <div className="form-group col-md-6 mt-2 mb-2">
                                                        <label htmlFor="businessName" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Business Name</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control uprofile update-profile-business_name-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0 ${errors.timezone ? "is-invalid" : ""}`}
                                                            name="businessName"
                                                            value={businessName}
                                                            onChange={(e) => setBusinessName(e.target.value)}
                                                            placeholder="Enter Business Name"
                                                        />
                                                    </div>
                                                    {errors.businessName && <span className="error-msgs text-danger">{errors.businessName}</span>}
                                                </div>

                                                {/* Save Changes Button */}
                                                <div className="d-flex mt-3">
                                                    <button type="submit" className="btn btn-theme btn-shadow me-2 px-6 personal-info-sbt">
                                                        {loading ? (
                                                            <>Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span></>
                                                        ) : (
                                                            " Save Changes"
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Change Password Section */}
                        <div className="row setting" style={{ display: isFormVisible2 ? 'block' : 'none' }}>
                            <div className="col-md-12">
                                <div className="card rounded-4 mb-5 mb-xl-10">
                                    {/* Card Header */}
                                    <div className="card-header border-0  rounded-4  cursor-pointer" role="button" style={{ background: 'white' }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0 p-info-header make_blur">Change Password</h3>
                                        </div>
                                    </div>

                                    {/* Change Password Form */}
                                    <div id="kt_account_settings_password" className="collapse show">
                                        <form action="" className="form fv-plugins-bootstrap5 fv-plugins-framework">
                                            <div className="card-body border-top p-9">
                                                <div className="row">
                                                    <div className="form-group col-md-4 mt-2 mb-2">
                                                        <label htmlFor="password" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Current Password  <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type={showPasswordRe ? 'text' : 'password'}
                                                                className={` form-control uprofile update-profile-password-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0  ${errors.current ? 'is-invalid' : ''}`}
                                                                name="password"
                                                                value={current}
                                                                onChange={(e) => setCurrent(e.target.value)}
                                                                placeholder="Enter Current Password"
                                                            />
                                                            <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                                                <i
                                                                    className={`bi bi-eye-slash fs-4 text-muted ${showPasswordRe ? 'd-none' : ''}`}
                                                                    onClick={togglePasswordVisibilityRe}
                                                                ></i>
                                                                <i
                                                                    className={`bi bi-eye fs-4  text-primary ${showPasswordRe ? '' : 'd-none'}`}
                                                                    onClick={togglePasswordVisibilityRe}
                                                                ></i>
                                                            </div>
                                                            {errors.current && <span className="error-msgs text-danger">{errors.current}</span>}
                                                        </div>
                                                        <div className='form-text ' style={{ marginBottom: '1.25rem', marginTop: '0.5rem', fontSize: '0.95rem' }}>Use 8 or more characters with a mix of letters, at least one capital letter, one number, and one special character.</div>
                                                    </div>

                                                    <div className="form-group col-md-4 mt-2 mb-2">
                                                        <label htmlFor="newPassword" className="form-label fs-6 fw-normal mb-3">
                                                            <b>New Password  <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                className={` form-control uprofile update-profile-new_password-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0  ${errors.password ? 'is-invalid' : ''}`}
                                                                name="newPassword"
                                                                placeholder="Enter New Password" />
                                                            <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                                                <i
                                                                    className={`bi bi-eye-slash fs-4 text-muted ${showPassword ? 'd-none' : ''}`}
                                                                    onClick={togglePasswordVisibility}
                                                                ></i>
                                                                <i
                                                                    className={`bi bi-eye fs-4  text-primary ${showPassword ? '' : 'd-none'}`}
                                                                    onClick={togglePasswordVisibility}
                                                                ></i>
                                                            </div>
                                                            {errors.password && <span className="error-msgs text-danger">{errors.password}</span>}
                                                        </div>
                                                    </div>

                                                    <div className="form-group col-md-4 mt-2 mb-2">
                                                        <label htmlFor="confirmPassword" className="form-label fs-6 fw-normal mb-3">
                                                            <b>Re-type New Password <span className="required-field text-danger">*</span></b>
                                                        </label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type={showPasswordRec ? 'text' : 'password'}
                                                                value={passre}
                                                                onChange={(e) => setPassre(e.target.value)}
                                                                className={` form-control uprofile update-profile-confirm_password-inp form-control-lg form-control-solid mb-3 mb-lg-0 py-0  ${errors.passre ? 'is-invalid' : ''}`}
                                                                name="confirmPassword"
                                                                placeholder="Enter Re-type New Password"
                                                            />
                                                            <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                                                <i
                                                                    className={`bi bi-eye-slash fs-4 text-muted ${showPasswordRec ? 'd-none' : ''}`}
                                                                    onClick={togglePasswordVisibilityRec}
                                                                ></i>
                                                                <i
                                                                    className={`bi bi-eye fs-4  text-primary ${showPasswordRec ? '' : 'd-none'}`}
                                                                    onClick={togglePasswordVisibilityRec}
                                                                ></i>
                                                            </div>
                                                        </div>
                                                        {errors.passre && <span className="error-msgs text-danger">{errors.passre}</span>}
                                                    </div>
                                                </div>

                                                {/* Save Password Changes Button */}
                                                <div className="d-flex mt-3">
                                                    <button type="submit" onClick={handleUpdatePassword} className="btn btn-theme btn-shadow me-2 px-6 personal-info-sbt">
                                                        {loading2 ? (
                                                            <>Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span></>
                                                        ) : (
                                                            "Save Changes "
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Change Password Section */}
                        <div className="set-password">
                            <div className="card mb-5 mb-xl-10 set-password-card " style={{ display: isFormVisible ? 'block' : 'none' }}>
                                {/* Card header */}
                                <div className="card-header border-0 rounded-4  cursor-pointer"
                                    role="button" style={{ background: 'white' }}
                                    onClick={() => setIsFormVisible(!isFormVisible)}>
                                    <div className="card-title m-0 ">
                                        <h3 className="fw-bold m-0 set-pass-header make_blur">Set Password</h3>
                                    </div>
                                </div>

                                {/* Form section */}
                                <div className={`collapse ${isFormVisible ? 'show' : ''}`}>
                                    <div className="card-body border-top p-9">
                                        {/* Change Password */}
                                        <div className="d-flex flex-wrap align-items-center">
                                            <div className="row">
                                                <div className="mt-3 mb-3 set-password-card">
                                                    <div>
                                                        <div className="set-password-head mt-3">
                                                            <div className="sloader-set-password"></div>
                                                            <div className="set-password mt-3 mb-3"
                                                                style={{ display: isFormVisible ? 'block' : 'none' }}>
                                                                <form id="set-password-form" onSubmit={handleFormEmailSubmit}
                                                                    className="form fv-plugins-bootstrap5 fv-plugins-framework" noValidate>

                                                                    <div className="row">
                                                                        {/* New Password */}
                                                                        <div className="form-group col-md-6 mt-2 mb-2">
                                                                            <label
                                                                                htmlFor="new_password"
                                                                                className="form-label fs-6 fw-normal mb-3"
                                                                            >
                                                                                <b>
                                                                                    New Password <span className="required-field text-danger">*</span>
                                                                                </b>
                                                                            </label>
                                                                            <div style={{ position: 'relative' }}>
                                                                                <input
                                                                                    type={showPasswordRe ? 'text' : 'password'}
                                                                                    className={` form-control setPassword set-password-new_password-inp form-control-lg form-control-solid  ${errors.newPassowrd ? 'is-invalid' : ''}`}
                                                                                    name="new_password"
                                                                                    value={newPassowrd}
                                                                                    onChange={(e) => setNewPassowrd(e.target.value)}
                                                                                    placeholder="Enter New Password"
                                                                                />
                                                                                <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                                                                    <i
                                                                                        className={`bi bi-eye-slash fs-4 text-muted ${showPasswordRe ? 'd-none' : ''}`}
                                                                                        onClick={togglePasswordVisibilityRe}
                                                                                    ></i>
                                                                                    <i
                                                                                        className={`bi bi-eye fs-4  text-primary ${showPasswordRe ? '' : 'd-none'}`}
                                                                                        onClick={togglePasswordVisibilityRe}
                                                                                    ></i>
                                                                                </div>
                                                                                {errors.newPassowrd && <span className="error-msgs text-danger">{errors.newPassowrd}</span>}
                                                                            </div>
                                                                            <div className="form-text mb-5">
                                                                                Use 8 or more characters with a mix of letters, at least one capital letter, one number, and one special character.
                                                                            </div>
                                                                        </div>

                                                                        {/* Confirm Password */}
                                                                        <div className="form-group col-md-6 mt-2 mb-2">
                                                                            <label
                                                                                htmlFor="confirm_password"
                                                                                className="form-label fs-6 fw-normal mb-3"
                                                                            >
                                                                                <b>
                                                                                    Confirm Password <span className="required-field text-danger">*</span>
                                                                                </b>
                                                                            </label>
                                                                            <div style={{ position: 'relative' }}>
                                                                                <input
                                                                                    type={showPassword ? 'text' : 'password'}
                                                                                    className={` form-control setPassword set-password-confirm_password-inp form-control-lg form-control-solid  ${errors.confirmnewPassword ? 'is-invalid' : ''}`}
                                                                                    name="confirm_password"
                                                                                    value={confirmnewPassword}
                                                                                    onChange={(e) => setConfirmnewPassword(e.target.value)}
                                                                                    placeholder="Enter Confirm Password"
                                                                                />
                                                                                <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                                                                    <i
                                                                                        className={`bi bi-eye-slash fs-4 text-muted ${showPassword ? 'd-none' : ''}`}
                                                                                        onClick={togglePasswordVisibility}
                                                                                    ></i>
                                                                                    <i
                                                                                        className={`bi bi-eye fs-4  text-primary ${showPassword ? '' : 'd-none'}`}
                                                                                        onClick={togglePasswordVisibility}
                                                                                    ></i>
                                                                                </div>
                                                                                {errors.confirmnewPassword && <span className="error-msgs text-danger">{errors.confirmnewPassword}</span>}
                                                                            </div>
                                                                        </div>

                                                                        {/* Submit Button */}
                                                                        <div className="d-flex mt-3">
                                                                            <button type="submit" className="btn btn-theme btn-shadow me-2 px-6 personal-info-sbt">
                                                                                {loading3 ? (
                                                                                    <>Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span></>
                                                                                ) : (
                                                                                    "Save Changes "
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>

    );
};

export default Settings;
